import Bubble from 'components/bubble';
import Markdown from 'components/markdown';
import PropTypes from 'prop-types';

const Keyword = ({ description, keyword }) => {
  return (
    <>
      <dt className="text-center align-middle sm:col-span-1 sm:col-start-1 sm:w-60 sm:text-right">
        <Bubble>{keyword}</Bubble>
      </dt>
      <dd className="text-center sm:col-span-1 sm:col-start-2 sm:text-left">
        <Markdown>{description.replace(/ (\w+)$/, '&nbsp;$1')}</Markdown>
      </dd>
    </>
  );
};

Keyword.propTypes = {
  description: PropTypes.string.isRequired,
  keyword: PropTypes.string.isRequired,
};

export default Keyword;

// Warning: validateDOMNesting(...): <dt> cannot appear as a child of <tbody>.
//     at dt
//     at Keyword (/Users/chriserickson/Development/ginrickey/packages/site/src/components/keywords/keyword.jsx:9:20)
//     at tbody
//     at table
// Warning: validateDOMNesting(...): <dd> cannot appear as a child of <tbody>.
//     at dd
//     at Keyword (/Users/chriserickson/Development/ginrickey/packages/site/src/components/keywords/keyword.jsx:9:20)
//     at tbody
//     at table
